import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../features/collections/redux/actions';
import { ParentContentCardMultiHeader } from '../common/ParentContentCardMultiHeader';
import { builderSurfaceJsonContentHeader } from '../../common/utils/restApiHeaderUtils';
import axios from 'axios';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { getErrorMessageFromResponse } from '../../common/utils/errorUtils';
import { toast } from 'react-toastify';
import CustomReactPaginate from '../../common/custom/CustomReactPaginate';

export class ManagePermissions extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    page: 0,
    limit: 25,
    searchTerm: '',
    checkedItems: [],
    selectedUuid: '',
    selectAllCheckbox: false,
  };

  componentDidMount() {
    this.triggerLoadCollectionItems(this.state.page);
    const { collections } = this.props;
    const { selectedItem } = collections;
    if (selectedItem) {
      this.setState({ checkedItems: selectedItem.data.permissions });
      this.setState({ selectedUuid: selectedItem.data.uuid });
    }
  }

  handleCheckboxChange = (name) => {
    this.setState((prevState) => {
      const checkedItems = Array.isArray(prevState.checkedItems) ? prevState.checkedItems : [];
      if (checkedItems.includes(name)) {
        return {
          checkedItems: checkedItems.filter((item) => item !== name),
        };
      } else {
        return {
          checkedItems: [...checkedItems, name],
        };
      }
    });
  };

  handleSelectAllCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    this.setState({ selectAllCheckbox: isChecked });

    if (isChecked) {
      const allPermissionNames = this.props.collections.items.map((item) => item.name);
      this.setState({ checkedItems: allPermissionNames });
    } else {
      this.setState({ checkedItems: [] });
    }
  };

  updateSearchTerm = (value) => {
    this.setState({ searchTerm: value });
  };

  handleSearch = () => {
    const { collections } = this.props;
    const {
      selectedCollection: { collectionName },
    } = collections;
    const { searchTerm, page } = this.state;
    if (collectionName) {
      this.triggerLoadCollectionItems(page, searchTerm);
    }
  };

  onPageChange = (val) => {
    const {
      selectedCollection: { collectionName },
    } = this.props.collections;
    const { searchTerm } = this.state;
    if (collectionName) {
      this.triggerLoadCollectionItems(val.selected, searchTerm);
      this.setState({ page: val.selected });
    }
  };

  handleUpdate = () => {
    const { checkedItems, selectedUuid } = this.state;
    const { collections, match, history } = this.props;
    const { projectId, version } = match.params;
    const { selectedCollection } = collections;
    const uri = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/user/collection/${selectedUuid}`;
    const header = builderSurfaceJsonContentHeader(projectId);
    const doRequest = axios.patch(uri, { permissions: checkedItems }, header);
    doRequest.then(
      (res) => {
        if (res.status === 200 && res.data) {
          toast.success('Updated Successfully !');
          history.push(
            `/2.0/collections/${version}/v/${projectId}/items/${selectedCollection.uuid}/name/user`,
          );
        } else {
          const errMsg = getErrorMessageFromResponse(res);
          toast.error(`Updation Failed: ${errMsg} `);
        }
      },
      (err) => {
        const errMsg = getErrorMessageFromResponse(err.response);
        toast.error(`Updation Failed: ${errMsg} `);
      },
    );
  };

  triggerLoadCollectionItems = (page, searchTerm = '') => {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    const { limit } = this.state;
    const query = { projectId, collectionName: 'permission', page, limit, version };
    if (searchTerm) {
      query.searchTerm = searchTerm;
    }
    actions.loadCollectionItems(query);
  };

  renderCollectionData = () => {
    const { collections } = this.props;
    const { items } = collections;
    const { checkedItems } = this.state;

    if (!items || !items.length) {
      return (
        <tbody>
          <tr>
            <td></td>
            <td className="pl-5 align-middle text-center">No Data!</td>
          </tr>
        </tbody>
      );
    }

    return (
      <tbody>
        {items.map((item, i) => (
          <tr key={i}>
            <td style={{ paddingTop: '1px', paddingBottom: '1px' }}>
              <div className="form-check">
                <label className="form-check-label">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    onChange={() => this.handleCheckboxChange(item.name)}
                    checked={checkedItems ? checkedItems.includes(item.name) : false}
                  />
                  <span className="form-check-sign" style={{ marginLeft: '7px' }}>
                    <span className="check"></span>
                  </span>
                </label>
              </div>
            </td>
            <td>{item.name}</td>
          </tr>
        ))}
      </tbody>
    );
  };

  renderCollectionItem = () => {
    const { history, collections, match } = this.props;
    const { params } = match || '';
    const { projectId, version } = params || '';
    const { totalItemPages } = collections;
    const { page, searchTerm, selectAllCheckbox } = this.state;
    return (
      <div className="row mx-auto">
        <ParentContentCardMultiHeader
          isEnvironment
          isSearch
          btnSize="sm"
          handleSearch={this.handleSearch}
          updateSearchTerm={this.updateSearchTerm}
          title="Manage Permissions"
          icon="showConfirmationMessage"
          bgColor="drapcode-violet"
          projectId={projectId}
          version={version}
          refreshMethod={() => {
            this.triggerLoadCollectionItems(page, searchTerm);
          }}
        >
          <div className="row">
            <div className="col-md-12 col-lg-12 table-responsive">
              <table className="table table-bordered table-word-break">
                <thead>
                  <tr>
                    <th style={{ width: '2%', paddingBottom: '1px', paddingTop: '1px' }}>
                      <div className="form-check">
                        <label className="form-check-label">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            onChange={this.handleSelectAllCheckboxChange}
                            checked={selectAllCheckbox}
                          />
                          <span className="form-check-sign" style={{ marginLeft: '7px' }}>
                            <span className="check"></span>
                          </span>
                        </label>
                      </div>
                    </th>
                    <th>Permission Name</th>
                  </tr>
                </thead>
                {this.renderCollectionData()}
              </table>
              {totalItemPages > 1 && (
                <CustomReactPaginate
                  totalPages={totalItemPages}
                  pageRangeDisplayed={2}
                  marginPagesDisplayed={1}
                  page={page}
                  onPageChange={this.onPageChange}
                />
              )}
              <div className="d-flex justify-content-between mt-2">
                <button
                  type="button"
                  className="btn btn-md btn-theme-default-outlined"
                  onClick={() => history.goBack()}
                >
                  <span>
                    <i className={`wb webconnect-times`}></i>&nbsp;Cancel
                  </span>
                </button>
                &nbsp;
                <button onClick={this.handleUpdate} className="btn btn-md btn-theme-submit">
                  <span>
                    <i className={`wb webconnect-save-regular`}></i>&nbsp;Update
                  </span>
                </button>
              </div>
            </div>
          </div>
        </ParentContentCardMultiHeader>
      </div>
    );
  };
  render() {
    return (
      <CommonPageComponent parentClassName="collections-collection-edit">
        {this.renderCollectionItem()}
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ManagePermissions);
